import { useTranslation } from 'react-i18next'
import './UpdateBanner.scss'

/**
 * Presentational "a new version is available" toast (#533). Shown when a newer
 * release has been deployed than the one currently running. Dismissible; the
 * Refresh button reloads the page onto the latest build.
 */
const UpdateBanner = ({ show, onRefresh, onDismiss }) => {
  const { t } = useTranslation('common')

  if (!show) return null

  return (
    <div className="update-banner" role="status" aria-live="polite">
      <span className="update-banner__message">
        <span className="update-banner__icon" aria-hidden="true">&#x2728;</span>
        {t('updateBanner.message')}
      </span>
      <button type="button" className="update-banner__refresh" onClick={onRefresh}>
        {t('updateBanner.refresh')}
      </button>
      <button
        type="button"
        className="update-banner__dismiss"
        onClick={onDismiss}
        aria-label={t('updateBanner.dismiss')}
      >
        &times;
      </button>
    </div>
  )
}

export default UpdateBanner
